import LandingStats from './LandingStats';
import MainStats from './MainStats';
import ScenarioOneStats from './ScenarioOneStats';
import ScenarioThreeStats from './ScenarioThreeStats';
import ScenarioTwoStats from './ScenarioTwoStats';
import ScenarioFourStats from './ScenarioFourStats';
import styles from './StatsBar.module.scss';
import statReportIcon from 'assets/images/stat-report-icon.svg';
import {
    BASE_ROUTE,
    RM_ROUTE,
    SCENARIO_ONE_ROUTE,
    SCENARIO_THREE_ROUTE,
    SCENARIO_TWO_ROUTE,
    SCENARIO_FOUR_ROUTE,
    TEAM_ROUTE,
    MARKET_ROUTE
} from 'constants/routes';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
    selectLandingStats,
    selectMarketStat,
    selectMarketViewStats,
    selectRmStat,
    selectRmStatsReporting,
    selectScenarioOneStats,
    selectScenarioThreeStats,
    selectScenarioTwoStats,
    selectScenarioFourStats,
    selectTeamStat,
    selectTeamViewStats
} from 'selectors/selectors';

import MarketAndTeamStats from './MarketAndTeamStats';
import RmStats from './RmStats';

const StatsBar = () => {
    const { pathname: route } = useLocation();
    const marketStat = useSelector(selectMarketStat);
    const marketViewStat = useSelector(selectMarketViewStats);
    const teamStat = useSelector(selectTeamStat);
    const teamViewStat = useSelector(selectTeamViewStats);
    const rmStat = useSelector(selectRmStat);
    const landingStats = useSelector(selectLandingStats);
    const scenarioOneStats = useSelector(selectScenarioOneStats);
    const scenarioTwoStats = useSelector(selectScenarioTwoStats);
    const scenarioThreeStats = useSelector(selectScenarioThreeStats);
    const scenarioFourStats = useSelector(selectScenarioFourStats);
    const rmStatisticsReporting = useSelector(selectRmStatsReporting);
    const areAllRmStatisticsZero =
        rmStatisticsReporting &&
        Object.values(rmStatisticsReporting).every((value) => value === 0);
    const shouldShowResults =
        (route !== RM_ROUTE && typeof rmStat === 'number') ||
        (route === RM_ROUTE && !areAllRmStatisticsZero);
    return (
        <div
            className={
                shouldShowResults ? styles.wrapper : styles.noResultsWrapper
            }
        >
            {/* Stat Reporting Logo */}
            <div className={styles.logoContainer}>
                <div className={styles.logo}>
                    <div className={styles.icon}>
                        <img src={statReportIcon} alt="" />
                    </div>
                    <div className={styles.iconText}>
                        <div>Statistics</div>
                        <div>Reporting</div>
                    </div>
                </div>
            </div>

            <div className={styles.statsContainer}>
                {shouldShowResults ? (
                    <>
                        {route === RM_ROUTE ? (
                            <RmStats />
                        ) : (
                            <MainStats
                                marketStat={marketStat}
                                teamStat={teamStat}
                                rmStat={rmStat}
                            />
                        )}
                        {route === BASE_ROUTE && landingStats && (
                            <LandingStats />
                        )}
                        {route === MARKET_ROUTE && marketViewStat && (
                            <MarketAndTeamStats stats={marketViewStat} />
                        )}
                        {route === TEAM_ROUTE && teamViewStat && (
                            <MarketAndTeamStats stats={teamViewStat} />
                        )}
                        {route === SCENARIO_ONE_ROUTE && scenarioOneStats && (
                            <ScenarioOneStats />
                        )}
                        {route === SCENARIO_TWO_ROUTE && scenarioTwoStats && (
                            <ScenarioTwoStats />
                        )}
                        {route === SCENARIO_THREE_ROUTE &&
                            scenarioThreeStats && <ScenarioThreeStats />}
                        {route === SCENARIO_FOUR_ROUTE && scenarioFourStats && (
                            <ScenarioFourStats />
                        )}
                    </>
                ) : (
                    <div className={styles.noResultsWrapperText}>
                        No Results
                    </div>
                )}
            </div>
        </div>
    );
};

export default StatsBar;
